import { createStyles, makeStyles } from '@material-ui/core'

export const useCardStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      padding: 20,
      background: '#F2F2F2',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
    },
    avatar: {
      background: 'linear-gradient(180deg, #246193 0%, #46A4E0 100%), #FFFFFF',
      boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.25)'
    },
    header: {
      '& .MuiCardHeader-action': {
        margin: 0,
        fontSize: 16,
        '& small': {
          fontSize: 12,
          color: '#828282'
        }
      }
    },
    actions: {
      marginTop: 20,
      display: 'flex',
      justifyContent: 'space-around'
    },
    simpleAction: {
      color: '#828282',
      fontSize: '12px',
      textAlign: 'right',
      lineHeight: 1.43
    }
  })
)

export const useSubscriptionStyles = makeStyles({
  root: {
    width: '100%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '25px'
  },
  title: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '36px',
    lineHeight: '42px',
    color: '#333333',
    width: '100%',
    marginBottom: 23
  },
  description: {
    color: '#4F4F4F',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '14px',
    width: '100%',
    marginBottom: 23
  },
  list: {
    width: '100%',
    maxWidth: '1024px',
    margin: '0 auto'
  },
  flex: {
    display: 'flex'
  },
  overflow: {}
})
